import type { FraisDTO } from '@/features/api/extranet/dto/Demande/shared'
import type { ModeFrais, NatureFrais } from '@/features/domaine/types/opco'
import { HelpFraisAnnexe, HelpFraisPedagogique } from '@/features/domaine/types/opco/Demande/OUTILFPE'
import { storeToRefs } from 'pinia'
import { computed, type InjectionKey } from 'vue'
import { buildDemandeActions } from '../shared'
import type { FraisDataParMode } from '../shared/components/frais/Frais.types'
import { useDemandeOutilFPEStore } from './useDemandeOutilFPEStore.ts'

type DemandeOutilFpeActions = ReturnType<typeof useDemandeOutilFPEActions>
export const OUTIL_FPE_ACTIONS: InjectionKey<DemandeOutilFpeActions> = Symbol('outil-fpe-actions')

export function useDemandeOutilFPEActions() {
  const store = useDemandeOutilFPEStore()

  const { setupCustomUpdater } = store

  const { model, meta, estTT } = storeToRefs(store)

  //  typeDocumentTemplate: computed(() => null),
  const actionsDemande = buildDemandeActions(store)

  const fraisDataParMode = computed<FraisDataParMode>(() => {
    return {
      Pedagogique: {
        frais: [],
        metaFrais: [],
        fraisTitre: 'Frais Pédagogiques',
        fraisField: 'fraisPedagogiques',
        fraisHelp: HelpFraisPedagogique,
      },
      Annexe: {
        frais: model.value?.prestation?.fraisAnnexes || [],
        metaFrais: meta.value?.prestation?.fraisAnnexes,
        fraisTitre: 'Coût',
        fraisField: 'fraisAnnexesSalarie',
        fraisHelp: HelpFraisAnnexe,
      },
    }
  })

  const modifieFrais = setupCustomUpdater<{
    mode: ModeFrais
    nature: NatureFrais
    field: keyof FraisDTO
    valeur?: string | number | null
  }>((patch, { nature, field, valeur }) => {
    const listeFrais = patch.prestation!.fraisAnnexes!

    const fraisAModifier = listeFrais.find((f) => f.nature === nature)
    if (!fraisAModifier) {
      throw new Error(`Aucun frais trouvé pour la nature ${nature}`)
    }
    fraisAModifier[field] = valeur as any
  })

  return {
    ...actionsDemande,
    estTypePublicVisible: estTT,
    modifieFrais,
    fraisDataParMode,
  }
}
